export type MobileWebChoice = 'desktop' | 'web';
export type PhoneOs = 'android' | 'ios';
export type ChoiceStorage = { getItem: (key: string) => string | null; setItem?: (key: string, value: string) => void };

export const MOBILE_WEB_CHOICE_KEY = 'bomdisoft.mobile-web';
export const DESKTOP_VIEWPORT = 'width=1280';
export const GET_THE_APP_SEGMENT = 'get-the-app';
export const PHONE_USER_AGENT = /iPhone|iPod|Android.*Mobile/i;
export const IOS_USER_AGENT = /iPhone|iPod/i;
export const CRAWLER_USER_AGENT = /bot|crawl|spider|slurp|Googlebot|bingbot|Chrome-Lighthouse|HeadlessChrome/i;

export const detectPhoneOs = (userAgent: string): PhoneOs | null => {
  if (!PHONE_USER_AGENT.test(userAgent)) return null;
  return IOS_USER_AGENT.test(userAgent) ? 'ios' : 'android';
};

export const isCrawler = (userAgent: string): boolean => CRAWLER_USER_AGENT.test(userAgent);

export const isMobileWebChoice = (value: unknown): value is MobileWebChoice => value === 'desktop' || value === 'web';

export const readMobileWebChoice = (storage: ChoiceStorage | undefined): MobileWebChoice | null => {
  try {
    const value = storage?.getItem(MOBILE_WEB_CHOICE_KEY);
    return isMobileWebChoice(value) ? value : null;
  } catch {
    return null;
  }
};

export const writeMobileWebChoice = (storage: ChoiceStorage | undefined, choice: MobileWebChoice): boolean => {
  try {
    storage?.setItem?.(MOBILE_WEB_CHOICE_KEY, choice);
    return true;
  } catch {
    return false;
  }
};

export const stripLocale = (pathname: string): string => `/${pathname.split('/').filter(Boolean).slice(1).join('/')}`;

export const isGetTheAppPath = (pathname: string | null): boolean => pathname !== null && stripLocale(pathname) === `/${GET_THE_APP_SEGMENT}`;

export const safeNext = (next: string | null | undefined, lang: string): string => (next?.startsWith('/') && !next.startsWith('//') ? next : `/${lang}`);

export const getTheAppPath = ({ lang, next, os }: { lang: string; next: string; os: PhoneOs }): string => `/${lang}/${GET_THE_APP_SEGMENT}?os=${os}&next=${encodeURIComponent(next)}`;
